const FIND_DOG = 'FIND_DOG';
const FIND_ID_DOG = 'FIND_ID_DOG';
const SWITCH_TEMPERAMENT = 'SWITCH_TEMPERAMENT';
const CREATE_BREED = 'CREATE_BREED';
const FIND_TEMPERAMENTS = 'FIND_TEMPERAMENTS';
const FIND_ALL_DOGS = 'FIND_ALL_DOGS';
const DELETE_DOG = 'DELETE_DOG';
const FILTER_DOGS = 'FILTER_DOGS';
const CLEAN_FILTER = 'CLEAN_FILTER';
const FILTER_BREED = 'FILTER_BREED'

export {
    FIND_DOG,
    FIND_ID_DOG,
    SWITCH_TEMPERAMENT,
    CREATE_BREED,
    FIND_TEMPERAMENTS,
    FIND_ALL_DOGS,
    DELETE_DOG,
    FILTER_DOGS,
    CLEAN_FILTER,
    FILTER_BREED
}